import * as yup from "yup";

export const nonWorkingDaysValidator = yup.object().shape({
  name: yup.string().required(),
  start_date: yup.number().required(),
  end_date: yup.number().required(),
  repeat_yearly: yup.boolean(),
});
